import React from 'react';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'md',
    text
}) => {
    return (
        <div className="loading-overlay">
            <div className={`spinner ${size}`} />
            {text && <span className="loading-text">{text}</span>}
        </div>
    );
};
